// extracted by mini-css-extract-plugin
module.exports = {"preview":"RMY9P"};